export default __webpack_public_path__ + "static/media/codesnap.94545abf.PNG";